"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.loginRequest = (jwt) => ({
    jwt, type: types.LOGIN_REQUEST,
});
exports.loginSuccess = (request) => (Object.assign({ type: types.LOGIN_SUCCESS }, request));
exports.loginFailure = (errorMessage) => ({
    errorMessage, type: types.LOGIN_FAILURE,
});
exports.logoutRequest = () => ({
    type: types.LOGOUT_REQUEST,
});
exports.logoutSuccess = () => ({
    type: types.LOGOUT_SUCCESS,
});
exports.logoutFailure = (errorMessage) => ({
    errorMessage, type: types.LOGOUT_FAILURE,
});
//# sourceMappingURL=actions.js.map